import type { Address } from '../types';

/** Copy delivery values only. Historical label/rate/purchase identities never seed a new shipment. */
export function copyRecipientAddress(address: Address): Address {
  return {
    name: address.name || '', company: address.company || '', street1: address.street1,
    street2: address.street2 || '', city: address.city, state: address.state, zip: address.zip,
    country: address.country || 'US', email: address.email || '', phone: address.phone || '',
    gift: address.gift || '', product_type: address.product_type, tshirt_size: address.tshirt_size || '',
  };
}
